module.exports = __webpack_public_path__ + "static/media/sync.92f51119.svg";